import React, { useEffect, useState } from 'react';
import APMCp1 from './components/APMCp1';
import APMCp2 from './components/APMCp2';
import APMCp3 from './components/APMCp3';

import { getApmcByDepartmentId, getExistedSchemesAplication, getYardsAPMC, submitApmcFiles } from '../../auth/services/privateapicalling';
import { getApplicationExistencCheck } from '../../auth/services/privateapicalling';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { toast, ToastContainer } from 'react-toastify';
import { schemeIdMap } from '../../../core/data/json/apmc';

 
 
// ---------------------------------- IDs ----------------------------------

const APMC: React.FC = () => {

 
    const token = useSelector((state:any)=>state.auth.token);
    const userDetail = useSelector((state:any)=>state.auth.userDetails)
    const location = useLocation()
    
const [isGettingApplication, setIsGettingApplication] = useState(true)
  const [isAllowed,setIsAllowed] = useState(true);
  const [existData ,setExistData] = useState<any | null>(null);
  const [applicationId , setApplicationId] = useState<string | null>(null);
 
  const purpose = location.state?.purpose? location.state.purpose : existData?.scheme;
  // const couchID=location.state?.couchId? location.state.couchId : existData?.applicationDataId;
  const [couchID, setCouchID] = useState("")
  const [step, setStep] = useState<number>(1);

  const [formData, setFormData] = useState({

    //APMCp1 files
    district:  "",
    apmcName: "",
    taluka: "",
    copyOfMarketCommitteEstDet : null as any,
    certOfMarketCommitteCategory: null as any,
    scheme: "",
    purpose:   "",
    category_Label: "",
    planProjectCost:  null as any,
    estimateProjectCostAmount: [] as any[],
    purposeCosts: {} as {[key: string]: string},
    percentOfProjCostEligible:  "",
    planEstimateByApprovedPE: null as any,
    estimatePlanConstruction: null as any,
    isExistingConstructionOnProjSite: "",
    toolsEquipQuotations:  null as any,
    estimateCertifiedByGovtEngineer:  null as any,

    // APMCp2 file fields
    permissionFromAuthority: null as any,
    insuranceUndertakingPostConstruction: null as any,
    auditUndertakingAfterAssistance: null as any,
    schemeConditionsUndertaking: null as any,
    jointAccountAssistanceUndertaking: null as any,
    noPriorAssistanceUndertaking: null as any,
    registerMaintenanceUndertaking: null as any,
    repaymentOnViolationUndertaking: null as any,
    constructionCompletionCertificate: null as any,
    noOutstandingDuesUndertaking: null as any,
    constructionProcurementETendering: null as any,
    goodsProcurementETendering: null as any,
    guaranteeAssistance: null as any,
    
    // APMCp3 file fields
  isLandOwnedByMarketingCommitee: null as any,
     hasAssistanceApproved: "",
     assistanceDetails: [
       {
        dateField: "",
        scheme2: "",
        purpose2: "",
        sanctionedAmount: "",
        assistanceReceived: "",
        totalExpenditure: "",
        shortfall: "",
        workCompletionDetails:"",
        contributionRatio: "",
       }
     ],
     
     isMarktingCommitteeLocatedInGeneral: "no",
     marktingCommitteeLocatedInGeneral: null as any,
     isMarktingCommFinanciallyCapableOfExpense: "no",
     marktingCommFinanciallyCapableOfExpense: null as any,
     incExpenditureForLast3Yrs: null as any,
     auditIncExpenditureForLast3Yrs: null as any,
     existingFarmerFacilities: null as any,
     marketCessIncome5YrsLast: null as any,
     marketCessIncome5YrsNext: null as any,
     availingAssistance: null as any,
  });

 


// DROPDOWN OF 12no.
const [assistanceDetails, setAssistanceDetails] = useState([
  {
    dateField: "",
    scheme2: "",
    purpose2: "",
    sanctionedAmount: "",
    assistanceReceived: "",
    totalExpenditure: "",
    shortfall: "",
    workCompletionDetails:"",
    contributionRatio: "",
  }
]);

const storedSchemeData = JSON.parse(localStorage.getItem("selectedScheme") || "{}");


//--------------------------------APMC,DISTRICT,TALUKA---------------------------------------

  const [apmcOptions, setApmcOptions] = useState<any>([]);
  const [districtOptions , setDistrictOptions] = useState<any>([]);
  const [talukaOptions , setTalukaOptions] = useState<any>([]);
  const [schemeIdd, setSchemeIdd] = useState('')
  const [uploadLoading, setUploadLoading] = useState(false);
  const schemeName = location?.state?.scheme?.name;
  const schemeId = schemeIdMap[schemeName] || "";


//----------------------------------FETCH API----------------------------------
  const fetchDistrict =async()=>{
    try {
      const depId=userDetail.Department_ID;
      const response = await getApmcByDepartmentId(token , depId);
  
 
      const districts = response.data.map((d) => ({
        label: d.District,
        value: d.district_id,
      }));
   
      const taluka = response.data.map((d) => ({
        label: d.Taluka,
        value: d.district_id,
      }));
      const apmc = response.data.map((d) => ({
        label: d.apmcName,
        value: d.id,
      }));
 
      setDistrictOptions(districts);
      setTalukaOptions(taluka); 
      setApmcOptions(apmc);


    // ✅ Pre-select first available values into formData
    if (districts.length && taluka.length && apmc.length) {
      setFormData(prev => ({
        ...prev,
        district: districts[0].label,
        taluka: taluka[0].label,
        apmcName: apmc[0].label,
        // district2:districts[0].label,
      }));
    }

 
    } catch (error) {
      
      toast.error('Internal Server Error',{position:"top-right"})
    }
  }
   useEffect(()=>{
    // getExistedApplication();
      setSchemeIdd(schemeId);
      fetchDistrict();
  },[])

//-----------------------------------Scheme and Purpose---------------------------
useEffect(() => {
 
    setFormData(prev => ({
      ...prev,
      district: existData?.annexureOne?.apmc?.data?.find((item: any) => item.fieldName === "District")?.value || districtOptions[0]?.label ,
      apmcName: existData?.annexureOne?.apmc?.data?.find((item: any) => item.fieldName === "apmcName")?.value || apmcOptions[0]?.label ,
      taluka: existData?.annexureOne?.apmc?.data?.find((item: any) => item.fieldName === "Taluka")?.value || talukaOptions[0]?.label ,
      copyOfMarketCommitteEstDet: existData?.annexureOne?.copyOfMarketCommitteEstDet?.data ? existData?.annexureOne?.copyOfMarketCommitteEstDet?.data[0] : null,
      category_Label: existData?.annexureOne?.certOfMarketCommitteCategory?.data ? existData?.annexureOne?.certOfMarketCommitteCategory?.data[0]?.value : null,
      certOfMarketCommitteCategory: existData?.annexureOne?.certOfMarketCommitteCategory?.data ? existData?.annexureOne?.certOfMarketCommitteCategory?.data[1] : null,
      scheme: existData?.scheme?.name?existData?.scheme?.name:"",
      // purpose: existData?.annexureOne?.purposeOfAssistance?.data ? existData?.annexureOne?.purposeOfAssistance?.data?.find((item: any) => item.fieldName === "purpose")?.value : "",
      planProjectCost: existData?.annexureOne?.estimateProjectCost?.data[0] ? existData?.annexureOne?.estimateProjectCost?.data[0] : null,
      estimatePlanConstruction: existData?.annexureOne?.estimatePlanConstruction?.data[0] ? existData?.annexureOne?.estimatePlanConstruction?.data[0] : null,
      // estimateProjectCostAmount:existData?.annexureOne?.estimateProjectCost?existData?.annexureOne?.estimateProjectCost?.data?.find((item: any) => item.fieldName === "estimateProjectCostAmount")?.value : "",
          estimateProjectCostAmount: existData?.annexureOne?.estimateProjectCost?.data
      ? existData?.annexureOne?.estimateProjectCost?.data.find(
          (item: any) => item.fieldName === "estimateProjectCostAmount"
        )?.value || []
      : [],
      percentOfProjCostEligible: existData?.annexureOne?.percentOfProjCostEligible?.data ? existData?.annexureOne?.percentOfProjCostEligible?.data[0]?.value : "",
      planEstimateByApprovedPE: existData?.annexureOne?.planEstimateByApprovedPE?.data ? existData?.annexureOne?.planEstimateByApprovedPE?.data[0] : null,
      isExistingConstructionOnProjSite: existData?.annexureOne?.isExistingConstructionOnProjSite?.data ? existData?.annexureOne?.isExistingConstructionOnProjSite?.data[0]?.value : "",
      toolsEquipQuotations: existData?.annexureOne?.toolsEquipQuotations?.data ? existData?.annexureOne?.toolsEquipQuotations?.data[0] : null,
      estimateCertifiedByGovtEngineer: existData?.annexureOne?.estimateCertifiedByGovtEngineer?.data ? existData?.annexureOne?.estimateCertifiedByGovtEngineer?.data[0] : null,
      permissionFromAuthority: existData?.annexureTwo?.permissionFromAuthority?.data ? existData?.annexureTwo?.permissionFromAuthority?.data[0] : null,
      insuranceUndertakingPostConstruction: existData?.annexureTwo?.insuranceUndertakingPostConstruction?.data ? existData?.annexureTwo?.insuranceUndertakingPostConstruction?.data[0] : null,
      auditUndertakingAfterAssistance: existData?.annexureTwo?.auditUndertakingAfterAssistance?.data ? existData?.annexureTwo?.auditUndertakingAfterAssistance?.data[0] : null,
      schemeConditionsUndertaking: existData?.annexureTwo?.schemeConditionsUndertaking?.data ? existData?.annexureTwo?.schemeConditionsUndertaking?.data[0] : null,
      jointAccountAssistanceUndertaking: existData?.annexureTwo?.jointAccountAssistanceUndertaking?.data ? existData?.annexureTwo?.jointAccountAssistanceUndertaking?.data[0] : null,
      noPriorAssistanceUndertaking: existData?.annexureTwo?.noPriorAssistanceUndertaking?.data ? existData?.annexureTwo?.noPriorAssistanceUndertaking?.data[0] : null,
      registerMaintenanceUndertaking: existData?.annexureTwo?.registerMaintenanceUndertaking?.data ? existData?.annexureTwo?.registerMaintenanceUndertaking?.data[0] : null,
      repaymentOnViolationUndertaking: existData?.annexureTwo?.repaymentOnViolationUndertaking?.data ? existData?.annexureTwo?.repaymentOnViolationUndertaking?.data[0] : null,
      constructionCompletionCertificate: existData?.annexureTwo?.constructionCompletionCertificate?.data ? existData?.annexureTwo?.constructionCompletionCertificate?.data[0] : null,
      noOutstandingDuesUndertaking: existData?.annexureTwo?.noOutstandingDuesUndertaking?.data ? existData?.annexureTwo?.noOutstandingDuesUndertaking?.data[0] : null,
      constructionProcurementETendering: existData?.annexureTwo?.constructionProcurementETendering?.data ? existData?.annexureTwo?.constructionProcurementETendering?.data[0] : null,
      goodsProcurementETendering: existData?.annexureTwo?.goodsProcurementETendering?.data ? existData?.annexureTwo?.goodsProcurementETendering?.data[0] : null,
      guaranteeAssistance: existData?.annexureTwo?.guaranteeAssistance?.data ? existData?.annexureTwo?.guaranteeAssistance?.data[0] : null,
      isLandOwnedByMarketingCommitee: existData?.annexureThree?.isLandOwnedByMarketingCommitee?.data ? existData?.annexureThree?.isLandOwnedByMarketingCommitee?.data[0] : null,
      hasAssistanceApproved: existData?.annexureThree?.hasAssistanceApproved?.data[0] ? existData?.annexureThree?.hasAssistanceApproved?.data[0]?.value : "no",
      assistanceDetails: existData?.annexureThree?.hasAssistanceApproved?.data
        ? existData?.annexureThree?.hasAssistanceApproved?.data
          .filter((item: any) => item.fieldName && item.fieldName.startsWith("details_"))
              .sort((a: any, b: any) => {
                const numA = parseInt(a.fieldName.split("_")[1], 10);
                const numB = parseInt(b.fieldName.split("_")[1], 10);
                return numA - numB;
              })
              .map((item: any) => ({
                dateField: item.value?.date || "",
                scheme2: item.value?.scheme || "",
                purpose2: item.value?.purpose || "",
                sanctionedAmount: item.value?.amount || "",
                assistanceReceived: item.value?.assistance || "",
                totalExpenditure: item.value?.expenditure || "",
                shortfall: item.value?.shortfall || "",
                workCompletionDetails: item.value?.completion || "",
                contributionRatio: item.value?.contribution || "",
              }))
            :   [
  {
    dateField: "",
    scheme2: "",
    purpose2: "",
    sanctionedAmount: "",
    assistanceReceived: "",
    totalExpenditure: "",
    shortfall: "",
    workCompletionDetails:"",
    contributionRatio: "",
  }
],
      isMarktingCommitteeLocatedInGeneral: existData?.annexureThree?.isMarktingCommitteeLocatedInGeneral?.data ? existData?.annexureThree?.isMarktingCommitteeLocatedInGeneral?.data?.find((item: any) => item.fieldName === "isApproved")?.value : "no",
      marktingCommitteeLocatedInGeneral: existData?.annexureThree?.isMarktingCommitteeLocatedInGeneral?.data ? existData?.annexureThree?.isMarktingCommitteeLocatedInGeneral?.data[1] : null,
      isMarktingCommFinanciallyCapableOfExpense: existData?.annexureThree?.isMarktingCommFinanciallyCapableOfExpense?.data ? existData?.annexureThree?.isMarktingCommFinanciallyCapableOfExpense?.data?.find((item: any) => item.fieldName === "isApproved")?.value : "no",
      marktingCommFinanciallyCapableOfExpense: existData?.annexureThree?.isMarktingCommFinanciallyCapableOfExpense?.data ? existData?.annexureThree?.isMarktingCommFinanciallyCapableOfExpense?.data[1] : null,
      incExpenditureForLast3Yrs: existData?.annexureThree?.incExpenditureForLast3Yrs?.data ? existData?.annexureThree?.incExpenditureForLast3Yrs?.data[0] : null,
      auditIncExpenditureForLast3Yrs: existData?.annexureThree?.auditIncExpenditureForLast3Yrs?.data ? existData?.annexureThree?.auditIncExpenditureForLast3Yrs?.data[0] : null,
      existingFarmerFacilities: existData?.annexureThree?.existingFarmerFacilities?.data ? existData?.annexureThree?.existingFarmerFacilities?.data[0] : null,
      marketCessIncome5YrsLast: existData?.annexureThree?.marketCessIncome5YrsLast?.data ? existData?.annexureThree?.marketCessIncome5YrsLast?.data[0] : null,
      marketCessIncome5YrsNext: existData?.annexureThree?.marketCessIncome5YrsLast?.data ? existData?.annexureThree?.marketCessIncome5YrsLast?.data[1] : null,
      availingAssistance: existData?.annexureThree?.availingAssistance?.data ? existData?.annexureThree?.availingAssistance?.data[0] : null,
    }));
   
    setAssistanceDetails(
       existData?.annexureThree?.hasAssistanceApproved?.data
         ? existData.annexureThree.hasAssistanceApproved.data
              .filter((item: any) => item.fieldName && item.fieldName.startsWith("details_"))
              .sort((a: any, b: any) => {
                const numA = parseInt(a.fieldName.split("_")[1], 10);
                const numB = parseInt(b.fieldName.split("_")[1], 10);
                return numA - numB;
              })
              .map((item: any) => ({
                dateField: item.value?.date || "",
                scheme2: item.value?.scheme || "",
                purpose2: item.value?.purpose || "",
                sanctionedAmount: item.value?.amount || "",
                assistanceReceived: item.value?.assistance || "",
                totalExpenditure: item.value?.expenditure || "",
                shortfall: item.value?.shortfall || "",
                workCompletionDetails: item.value?.completion || "",
                contributionRatio: item.value?.contribution || "",
              }))
            :  [
  {
    dateField: "",
    scheme2: "",
    purpose2: "",
    sanctionedAmount: "",
    assistanceReceived: "",
    totalExpenditure: "",
    shortfall: "",
    workCompletionDetails:"",
    contributionRatio: "",
  }
]
     );
}, [existData]);
useEffect(() => {
  const selectedScheme = localStorage.getItem('apmcSelectedScheme');
  const selectedPurpose = localStorage.getItem('apmcSelectedPurpose');

  // if (selectedScheme || selectedPurpose) {
  //   setFormData(prev => ({
  //     ...prev,
  //     scheme: selectedScheme || "",
  //     purpose: selectedPurpose || "",
  //   }));
  // }
  if (existData?.annexureOne?.estimateProjectCost?.data) {
    const costData = existData.annexureOne.estimateProjectCost.data.find(
      (item: any) => item.fieldName === "estimateProjectCostAmount"
    )?.value;
    
    if (Array.isArray(costData)) {
      const costsMap: {[key: string]: string} = {};
      costData.forEach((item: any) => {
        costsMap[item.id] = item.cost?.toString() || "";
      });
      
      // Update to use setFormData instead of setPurposeCosts
      setFormData(prev => ({
        ...prev,
        purposeCosts: costsMap
      }));
    }
  }
}, [existData]);

  const getExistedApplication = async (applicationId: string) => {
    try {
      const response = await getExistedSchemesAplication(token, applicationId, schemeIdd);
   
      if (response?.success) {
         setExistData(response?.data);
      }
    } catch (error) {
     
    }
  }
//----------------------------------STEPS FOR NEXT & BACK----------------------------------

  const handleNext = (): void => {
    if (step < 3) setStep(step + 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });

  };
 
  const handleBack = (): void => {
    if (step > 1) setStep(step - 1);
    window.scrollTo({ top: 0, behavior: 'smooth' });

  };

  // Properly typed helper function
  const getStepColor = (num: number): string => {
    return step >= num ? 'lightblue ' : 'white';
  };

  // Show tick icon if completed, else step number
const getStepContent = (stepIndex: number): React.ReactNode => {
  return step > stepIndex ? (
    <i className="fas fa-check text-white"></i> // font-awesome tick
  ) : (
    stepIndex
  );
};

const getStepStyle = (stepIndex: number): React.CSSProperties => {
  if (step > stepIndex) {
    return {
      backgroundColor: 'lightblue',
      border: '1px solid lightblue',
      color: 'white'
    };
  } else if (step === stepIndex) {
    return {
      backgroundColor: 'white',
      border: '2px solid #0d6efd', // Bootstrap primary blue
      color: '#0d6efd'
    };
  } else {
    return {
      backgroundColor: 'white',
      border: '1px solid #ccc',
      color: '#000'
    };
  }
};



// ----------------------------------Handle Inputs----------------------------------


  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>, fieldName: string,index?:any) => {

  const { name, files } = e.target;

   if (files && files.length > 0) {
     const file = files[0];
     const fileName = file.name;
     
      let docId:any;
      handleUpload(fileName,file, fieldName ,formData[fieldName]?.docId ,index);
      
    }


};

const handleUpload = async (documentName: string,file:any , fieldName:string , docId?: string | null,index?:any ) => {
    // if (!formData[fieldName]) return;
 
    const formData = new FormData();
    formData.append("file", file );
    formData.append("documentName", fieldName);
    formData.append("fieldName", documentName);
    formData.append("applicationId", applicationId);
    formData.append("schemeId",schemeIdd)
 
 
    try {
      setUploadLoading(true);
      const res = await submitApmcFiles(formData, token, docId);
  
      
      if(res.success==false)
        {
       
        toast.error(res?.message,{position:"top-right"})
  
      }
      else if (res.success && res.docId) {
       
      // Store docId and documentName in formData
      if(index!==undefined){
      const updated = [...assistanceDetails ];
  updated[index][fieldName] = {
    docId:res?.docId,
    documentName:fieldName,
    fileName:documentName
  };
  setAssistanceDetails(updated)
  toast.success(res?.message,{position:"top-right"})
      }else

  {    setFormData(prev => ({
        ...prev,
        [fieldName]: {
          docId: res.docId,
          documentName: fieldName,
          fileName: documentName,
        }
      }));
    toast.success(res?.message,{position:"top-right"})
    }
    }
    } catch (error) {
      toast.error("File upload failed",{position:"top-right"});
    } finally{
      setUploadLoading(false);
    }
  };

const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  const { name, value } = e.target;
 
  if (name === "percentOfProjCostEligible") {
    setFormData(prev => ({
      ...prev,
      percentOfProjCostEligible: value,
    }));
  } 
  else if (name === "estimateProjectCostAmount" && parseFloat(value) < 0) 
    {return;
     } else {
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  }
};



  useEffect(() => {
getExistedApplication(applicationId);
    // fetchApplicationExistenceCheck();

  }
  ,[step])
//  schemeIdMap

  return (
         
      <div className="m-5">
      {/* Fixed Header + Stepper */}
      <div className="position-fixed page-wrapper start-0 end-0 z-3 py-2 border-bottom"
        style={{
        padding: "1rem",
        backgroundColor: "#f8f9fa", // or specify same color code
      }}>
        {/* <h1 className="text-primary mb-4">
          Scheme: {formData.scheme || "No Scheme Selected"}
        </h1> */}
        <h3>
          Application for Scheme - {`${location?.state?.scheme?.name || "No Scheme Selected"}`}
        </h3>

        <div className="m-3 d-flex justify-content-center align-items-center">

      {/* Step 1 */}
      <div
        className="rounded-circle d-flex justify-content-center align-items-center"
        style={{
          height: "50px",
          width: "50px",
          backgroundColor: step > 1 ? '#1b84ff' : 'white',
          border: step === 1 ? '2px solid #1b84ff' : '1px solid lightblue',
          color: step > 1 ? 'white' : '#0d6efd',
          fontSize:"1.5rem"
        }}
      >
        {step > 1 ? <i className="feather feather-check text-white"></i> : 1}
      </div>

      <div className="bg-dark" style={{ height: "2px", width: "70px" }}></div>

      {/* Step 2 */}
      <div
        className="rounded-circle d-flex justify-content-center align-items-center"
        style={{
          height: "50px",
          width: "50px",
          backgroundColor: step > 2 ? '#1b84ff' : 'white',
          border: step === 2 ? '2px solid #1b84ff' : '1px solid lightblue',
          color: step > 2 ? 'white' : '#0d6efd',
          fontSize:"1.5rem"
        }}
      >
        {step > 2 ? <i className="feather feather-check text-white"></i> : 2}
      </div>

      <div className="bg-dark" style={{ height: "2px", width: "70px" }}></div>

      {/* Step 3 */}
      <div
        className="rounded-circle d-flex justify-content-center align-items-center"
        style={{
          height: "50px",
          width: "50px",
          backgroundColor: step > 3 ? '#1b84ff' : 'white',
          border: step === 3 ? '2px solid #1b84ff' : '1px solid lightblue',
          color: step > 3 ? 'white' : '#0d6efd',
          fontSize:"1.5rem",
        }}
      >
        {step > 3 ? <i className="feather feather-check text-white "></i> : 3}
      </div>

    </div>

      </div>

      {/* Spacer for Fixed Header */}
      <div style={{ height: "100px" }}></div>

      {/* Step Form Display (scrollable content) */}
      {step === 1 && (
        <APMCp1
          onNext={handleNext}
          isGettingApplication={isGettingApplication}
          setIsGettingApplication={setIsGettingApplication}
          formData={formData}
          setFormData={setFormData}
          handleFileChange={handleFileChange}
          handleInputChange={handleInputChange}
          districtOptions={districtOptions}
          talukaOptions={talukaOptions}
          apmcOptions={apmcOptions}
          selectedSchemeDetails={storedSchemeData}
          userDetail={userDetail}
          schemesSelected={location?.state?.scheme?.name}
          applicationId={applicationId}
          setApplicationId={setApplicationId}
          couchID={couchID}
          setCouchID={setCouchID}
           getExistedApplication={getExistedApplication}
        />
      )}
      {step === 2 && (
        <APMCp2
          onNext={handleNext}
          onBack={handleBack}
          formData={formData}
              handleFileChange={handleFileChange}
              userDetail={userDetail}
              // purpose={purpose}
              schemeIdd={schemeIdd}
              applicationId={applicationId}
              couchID={couchID}
              token={token}
        />
      )}
      {step === 3 && (
        <APMCp3
          onBack={handleBack}
          formData={formData}
          handleFileChange={handleFileChange}
          handleInputChange={handleInputChange}
          assistanceDetails={assistanceDetails}
              setAssistanceDetails={setAssistanceDetails}
              selectedSchemeDetails={storedSchemeData}
              userDetail={userDetail}
              schemeIdd={schemeIdd}
              // purpose={purpose}
              applicationId={applicationId}
              couchID={couchID}
              token={token}
        />
      )}
              <ToastContainer position="top-left" autoClose={3000} />
              {uploadLoading && (
              <div className="position-fixed z-3 top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center" style={{ background: "rgba(0, 0, 0, 0.17)", zIndex: 1050 }}>
                <div className="bg-white p-4 rounded shadow d-flex flex-column align-items-center">
                  <div className="spinner-border text-primary mb-3" role="status">
                    <span className="visually-hidden">Uploading...</span>
                  </div>
                  <div className="fw-bold">Uploading, please wait...</div>
                </div>
              </div>
            )}
    </div>
  );
};
 
export default APMC;
